var map = {
	"./mock-server-browser/mock-server-browser.module": [
		"./src/app/mock-server-browser/mock-server-browser.module.ts",
		"mock-server-browser-mock-server-browser-module"
	],
	"./not-found/not-found.module": [
		"./src/app/not-found/not-found.module.ts",
		"not-found-not-found-module"
	],
	"./pages/download/download.component": [
		"./src/app/pages/download/download.component.ts",
		"pages-download-download-component"
	],
	"./pages/landing-page/landing-page.module": [
		"./src/app/pages/landing-page/landing-page.module.ts",
		"common",
		"pages-landing-page-landing-page-module"
	],
	"./pages/taste/taste.module": [
		"./src/app/pages/taste/taste.module.ts",
		"pages-taste-taste-module"
	],
	"./pages/wine-detail/wine-detail.module": [
		"./src/app/pages/wine-detail/wine-detail.module.ts",
		"common",
		"pages-wine-detail-wine-detail-module"
	],
	"./transfer-back/transfer-back.module": [
		"./src/app/transfer-back/transfer-back.module.ts",
		"transfer-back-transfer-back-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;